module.exports = __webpack_public_path__ + "static/media/upDownArrow.bfb1bcc3.svg";